<template>
    <div class="career-registration">
        <z-caption size="2xl" weight="600" class="u-bottom-margin--l-important">{{ textLocalize.title }}</z-caption>

        <form class="career-registration__form" @submit.prevent="onSubmit" v-if="!isSended">
            <div class="row">
                <div class="col-default-12">
                    <z-select
                        v-model="formValues.program"
                        :options="programsList"
                        :placeholder="textLocalize.programs"
                        required
                        ref="programsField"
                    />
                </div>
            </div>

            <div class="row">
                <div class="col-default-6 col-v-tablet-12">
                    <z-input
                        v-model="formValues.firstName"
                        name="firstName"
                        :placeholder="textLocalize.firstName"
                        clearable
                        required
                        ref="firstNameField"
                    />
                </div>
                <div class="col-default-6 col-v-tablet-12">
                    <z-input
                        v-model="formValues.secondName"
                        name="secondName"
                        :placeholder="textLocalize.secondName"
                        clearable
                        required
                        ref="secondNameField"
                    />
                </div>
            </div>

            <div class="row">
                <div class="col-default-6 col-v-tablet-12">
                    <z-input
                        v-model="formValues.thirdName"
                        name="thirdName"
                        :placeholder="textLocalize.thirdName"
                        clearable
                    />
                </div>
                <div class="col-default-6 col-v-tablet-12">
                    <z-date-picker
                        v-model="formValues.dob"
                        :placeholder="textLocalize.dob"
                        required
                        ref="dobField"
                    />
                </div>
            </div>

            <div class="row">
                <div class="col-default-6 col-v-tablet-12">
                    <z-input
                        v-model="formValues.email"
                        name="email"
                        type="email"
                        :placeholder="textLocalize.email"
                        clearable
                        required
                        ref="emailField"
                    />
                </div>
                <div class="col-default-6 col-v-tablet-12">
                    <z-input
                        v-model="formValues.phone"
                        name="phoneNumber"
                        type="tel"
                        :mask="{mask: '+{7} (000) 000-00-00'}"
                        :placeholder="textLocalize.phone"
                        clearable
                        required
                        ref="phoneField"
                    />
                </div>
            </div>

            <div class="row">
                <div class="col-default-12">
                    <z-select
                        v-model="studyPlace"
                        :options="institutionOptions"
                        :placeholder="textLocalize.studyPlace"
                    />
                </div>
            </div>

            <div
                v-if="studyPlace === 'vuz'"
                class="row"
            >
                <div class="col-default-6 col-v-tablet-12">
                    <z-select
                        v-model="formValues.vuz.name"
                        :options="vuzNameList"
                        :placeholder="textLocalize.institutionName"
                        required
                        ref="vuzNameField"
                    />
                </div>
                <div
                    v-if="formValues.vuz.name === 'other'"
                    class="col-default-6 col-v-tablet-12"
                >
                    <z-input
                        v-model="vuzNameOtherField"
                        name="vuzNameOther"
                        :placeholder="textLocalize.institutionName"
                        clearable
                        required
                    />
                </div>
                <div class="col-default-6 col-v-tablet-12">
                    <z-select
                        v-model="formValues.vuz.levelEducation"
                        :options="levelEducationOptions"
                        :placeholder="textLocalize.levelEducation"
                        required
                        ref="vuzLevelField"
                    />
                </div>
                <div class="col-default-6 col-v-tablet-12">
                    <z-input
                        v-model="formValues.vuz.course"
                        type="number"
                        name="vuzCourse"
                        :min-val="1"
                        :max-val="6"
                        :placeholder="textLocalize.course"
                        clearable
                        required
                        ref="vuzCourseField"
                    />
                </div>
                <div class="col-default-6 col-v-tablet-12">
                    <z-input
                        v-model="formValues.vuz.faculty"
                        name="vuzFaculty"
                        :placeholder="textLocalize.faculty"
                        clearable
                        required
                        ref="vuzFacultyField"
                    />
                </div>
                <div class="col-default-6 col-v-tablet-12">
                    <z-input
                        v-model="formValues.vuz.speciality"
                        name="speciality"
                        :placeholder="textLocalize.specialty"
                        clearable
                        required
                        ref="specialityField"
                    />
                </div>
                <div class="col-default-6 col-v-tablet-12">
                    <z-input
                        v-model="formValues.vuz.averageScore"
                        type="number"
                        name="vuzAverage"
                        :min-val="0"
                        :placeholder="textLocalize.averageScore"
                        clearable
                        required
                        ref="vuzAverageField"
                    />
                </div>
            </div>

            <div
                v-if="studyPlace === 'ssuz'"
                class="row"
            >
                <div class="col-default-6 col-v-tablet-12">
                    <z-select
                        v-model="formValues.ssuz.name"
                        :options="vuzNameList"
                        :placeholder="textLocalize.institutionName"
                        required
                        ref="ssuzNameField"
                    />
                </div>
                <div
                    v-if="formValues.ssuz.name === 'other'"
                    class="col-default-6 col-v-tablet-12"
                >
                    <z-input
                        v-model="ssuzNameOtherField"
                        name="ssuzNameOther"
                        :placeholder="textLocalize.institutionName"
                        clearable
                        required
                    />
                </div>
                <div class="col-default-6 col-v-tablet-12">
                    <z-select
                        v-model="formValues.ssuz.levelEducation"
                        :options="levelEducationOptions"
                        :placeholder="textLocalize.levelEducation"
                        required
                        ref="ssuzLevelField"
                    />
                </div>
                <div class="col-default-6 col-v-tablet-12">
                    <z-input
                        v-model="formValues.ssuz.course"
                        type="number"
                        name="ssuzCourse"
                        :min-val="1"
                        :max-val="6"
                        :placeholder="textLocalize.course"
                        clearable
                        required
                        ref="ssuzCourseField"
                    />
                </div>
                <div class="col-default-6 col-v-tablet-12">
                    <z-input
                        v-model="formValues.ssuz.faculty"
                        name="ssuzFaculty"
                        :placeholder="textLocalize.faculty"
                        clearable
                        required
                        ref="ssuzFacultyField"
                    />
                </div>
                <div class="col-default-6 col-v-tablet-12">
                    <z-input
                        v-model="formValues.vuz.speciality"
                        name="speciality"
                        :placeholder="textLocalize.specialty"
                        clearable
                        required
                        ref="specialityField"
                    />
                </div>
                <div class="col-default-6 col-v-tablet-12">
                    <z-input
                        v-model="formValues.ssuz.averageScore"
                        type="number"
                        name="ssuzAverage"
                        :min-val="0"
                        :placeholder="textLocalize.averageScore"
                        clearable
                        required
                        ref="ssuzAverageField"
                    />
                </div>
            </div>

            <div
                v-if="studyPlace === 'school'"
                class="row"
            >
                <div class="col-default-6 col-v-tablet-12">
                    <z-input
                        v-model="formValues.schoolClass"
                        type="number"
                        name="schoolClass"
                        :min-val="1"
                        :max-val="12"
                        :placeholder="textLocalize.schoolClass"
                        clearable
                        required
                        ref="schoolClassField"
                    />
                </div>
            </div>

            <div class="row">
                <div class="col-default-6 col-v-tablet-12">
                    <z-input
                        v-model="formValues.speciality"
                        name="speciality"
                        :placeholder="textLocalize.specialtySingle"
                        clearable
                        required
                        ref="specialityField"
                    />
                </div>
                <div class="col-default-6 col-v-tablet-12">
                    <z-select
                        v-model="formValues.areaPractice"
                        :options="areaPracticeOptions"
                        :placeholder="textLocalize.areaPractice"
                        required
                        ref="areaPracticeField"
                    />
                </div>
                <div class="col-default-12">
                    <z-textarea
                        v-model="formValues.problemSolve"
                        :placeholder="textLocalize.problemSolve"
                        name="problemSolve"
                        required
                        ref="problemSolveField"
                    />
                </div>
                <div class="col-default-12">
                    <z-textarea
                        v-model="formValues.experience"
                        :placeholder="textLocalize.experience"
                        name="experience"
                        required
                        ref="experienceField"
                    />
                </div>
            </div>

            <div class="row">
                <div class="col-default-12">
                    <p class="career-registration__title">{{ textLocalize.resume }}</p>
                    <z-input-file
                        name="file"
                        accept=".pdf, .doc, .zip, .rar"
                        size="m"
                        ref="fileField"
                        required
                        :max-size="20971520"
                        :show-accept-label="true"
                        @change="updateFileField"
                    />
                </div>
            </div>

            <div class="row">
                <div class="col-default-12">
                    <z-checkbox
                        :data="{
                            text: textLocalize.agreement,
                            id: 'agreement'
                        }"
                        size="m"
                        required
                        ref="agreementField"
                    />
                </div>
            </div>

            <div class="row">
                <div class="col-default-12">
                    <p class="career-registration__notification">
                        Поля помеченные * обязательны для заполнения
                    </p>
                    <z-button
                        type="submit"
                        class="career-registration__submit"
                    >
                        {{ textLocalize.submit }}
                    </z-button>

                    <p class="text-size-s border-error-text u-mt-2xs" v-if="errorMsg" v-html="errorMsg"></p>
                </div>
            </div>
        </form>

        <p class="text-size-xl u-semi-bold" v-else>
            Данные успешно отправлены
        </p>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { sendRegistration } from '@/api/program-registration';
import { useGetter } from '@/composable/useGetter'
import { buildFormData } from '@/composable/useBuildFormData'
import { vuzNameList, textLocalize, levelEducationOptions, areaPracticeOptions, institutionOptions } from './data/registrationData.js'
import { useRecaptcha } from '@/composable/useRecaptcha'

const {app} = useGetter(['app'])
const { initGRecaptcha, getRecaptchaToken } = useRecaptcha()

const isSended = ref(false)
const errorMsg = ref('')

const formValues = ref({
    program: '',
    firstName: '',
    secondName: '',
    thirdName: '',
    dob: '',
    email: '',
    phone: '',
    vuz: {
        name: '',
        levelEducation: levelEducationOptions[0].id,
        course: '',
        faculty: '',
        speciality: '',
        averageScore: '',
    },
    ssuz: {
        name: '',
        levelEducation: levelEducationOptions[0].id,
        course: '',
        faculty: '',
        speciality: '',
        averageScore: '',
    },
    schoolClass: '',
    speciality: '',
    areaPractice: areaPracticeOptions[0].id,
    problemSolve: '',
    resume: '',
    experience: '',
})
const studyPlace = ref('vuz')

/* form fields */
const programsField = ref(null)
const firstNameField = ref(null)
const secondNameField = ref(null)
const dobField = ref(null)
const phoneField = ref(null)
const emailField = ref(null)
const vuzNameField = ref(null)
const vuzLevelField = ref(null)
const vuzCourseField = ref(null)
const vuzFacultyField = ref(null)
const vuzAverageField = ref(null)
const ssuzNameField = ref(null)
const ssuzLevelField = ref(null)
const ssuzCourseField = ref(null)
const ssuzFacultyField = ref(null)
const ssuzAverageField = ref(null)
const schoolClassField = ref(null)
const areaPracticeField = ref(null)
const problemSolveField = ref(null)
const experienceField = ref(null)
const fileField = ref(null)
const agreementField = ref(null)

const vuzNameOtherField = ref()
const ssuzNameOtherField = ref()

/* end form fields */

const programsList = mergeArrays(app.value.components['program-registration-form'])

const defaultRequiredFields = [programsField, firstNameField, secondNameField, dobField, phoneField, emailField, areaPracticeField, problemSolveField, experienceField, fileField, agreementField]
const vuzRequiredFields = [vuzNameField, vuzLevelField, vuzCourseField, vuzFacultyField, vuzAverageField]
const ssuzRequiredFields = [ssuzNameField, ssuzLevelField, ssuzCourseField, ssuzFacultyField, ssuzAverageField]
const schoolRequiredFields = [schoolClassField]

const updateFileField = (file) => {
    formValues.value.resume = file?.[0]
}

const onSubmit = async () => {
    let isValid = true
    let requiredFields = defaultRequiredFields;

    switch (studyPlace.value){
    case 'vuz':
        requiredFields = requiredFields.concat(vuzRequiredFields);
        break;
    case 'ssuz':
        requiredFields = requiredFields.concat(ssuzRequiredFields);
        break;
    case 'school':
        requiredFields = requiredFields.concat(schoolRequiredFields);
        break
    }

    requiredFields.forEach(item => {
        if (item.value) {
            item.value?.validate()
            if (item.value.error) {
                isValid = false
            }
        }
    })

    if (formValues.value.vuz.name === 'other') {
        formValues.value.vuz.name = vuzNameOtherField.value;
    }
    if (formValues.value.ssuz.name === 'other') {
        formValues.value.ssuz.name = ssuzNameOtherField.value;
    }
    if (!isValid) return

    try {
        const recaptchaToken = await getRecaptchaToken()

        if (!recaptchaToken) {
            throw new Error('Failed to get reCAPTCHA token');
        }

        formValues.value.captcha = recaptchaToken
        sendForm()
    } catch (error) {
        console.error(error)
    }
}

const sendForm = () => {
    const formData = buildFormData(formValues.value)
    sendRegistration(formData)
        .then(data => {
            if (data.status === 'error') {
                errorMsg.value = data.message
            } else {
                isSended.value = true
            }
        })
        .catch(e => {
            console.log(e);
            errorMsg.value = textLocalize.sendError
        })
}

onMounted(()=> {
    const urlParams = new URLSearchParams(window.location.search);
    const programId = urlParams.get('program');

    if (programId) {
        const program = programsList.find(item => item.id === programId);

        if (program) {
            formValues.value.program = program.id;
        }
    }

    initGRecaptcha()
})

function mergeArrays(obj) {
    const mergedArray = [];

    for (const key in obj) {
        if (Array.isArray(obj[key])) {
            mergedArray.push(...obj[key]);
        }
    }

    return mergedArray;
}
</script>

<style lang="scss">
.career-registration {

    &__title {
        @include margin-level(top, M);
        @include margin-level(bottom, XS);
        @include typo-level(Xl);

        &:first-of-type {
            @include margin-level(top, XS);
        }
    }

    &__study-place{
        @include margin-level(bottom, M);
    }

    &__notification{
        margin: 0;
        @include typo-level(S);
    }

    &__submit{
        @include margin-level(top, 2XS)
    }
}

</style>
